// This file is auto-generated. Do not edit manually.

const routes = [
  "/",
  "/_app",
  "/_document",
  "/403",
  "/404",
  "/500",
  "/account/[[...index]]",
  "/api/health",
  "/booking/[slug]",
  "/client/[medspaSlug]",
  "/client/[medspaSlug]/affirm-payment",
  "/client/[medspaSlug]/consent-form/[consentFormSlug]",
  "/client/[medspaSlug]/intake-form/[intakeFormSlug]",
  "/client/[medspaSlug]/memberships/[clientMembershipId]",
  "/client/[medspaSlug]/receipt/[receiptId]",
  "/client/[medspaSlug]/sign-in",
  "/client/[medspaSlug]/[tab]",
  "/client/[medspaSlug]/[tab]/[appointmentAccessToken]",
  "/client/[medspaSlug]/[tab]/[appointmentAccessToken]/cancel",
  "/client/[medspaSlug]/[tab]/[appointmentAccessToken]/consent-form/[consentFormSlug]",
  "/client/[medspaSlug]/[tab]/[appointmentAccessToken]/intake-form/[intakeFormSlug]",
  "/client/[medspaSlug]/[tab]/[appointmentAccessToken]/reschedule",
  "/help-center",
  "/md-onboarding",
  "/online-store/[medspaSlug]",
  "/online-store/[medspaSlug]/gift-email-creator",
  "/online-store/[medspaSlug]/sign-in",
  "/online-store/[medspaSlug]/success",
  "/online-store/[medspaSlug]/[tab]",
  "/online-store/[medspaSlug]/[tab]/[membershipId]/sign-up",
  "/sign-in/[[...index]]",
  "/two-step-verification/[[...index]]",
  "/url/[uuid]",
  "/[medspaId]/adverse-reactions",
  "/[medspaId]/balance",
  "/[medspaId]/balance/cards/[cardId]",
  "/[medspaId]/balance/issue-card",
  "/[medspaId]/balance/send-money",
  "/[medspaId]/balance-impersonation-error",
  "/[medspaId]/bookkeeping",
  "/[medspaId]/bookkeeping/[tab]",
  "/[medspaId]/charts",
  "/[medspaId]/client-memberships/new",
  "/[medspaId]/clients",
  "/[medspaId]/clients/new",
  "/[medspaId]/clients/[slug]",
  "/[medspaId]/clients/[slug]/attachments/forms",
  "/[medspaId]/clients/[slug]/attachments/images",
  "/[medspaId]/clients/[slug]/consent-forms",
  "/[medspaId]/clients/[slug]/consent-forms/[formSlug]",
  "/[medspaId]/clients/[slug]/edit",
  "/[medspaId]/clients/[slug]/edit-note",
  "/[medspaId]/clients/[slug]/gfe/history",
  "/[medspaId]/clients/[slug]/intake-forms/[formSlug]",
  "/[medspaId]/clients/[slug]/media",
  "/[medspaId]/clients/[slug]/memberships/[clientMembershipId]",
  "/[medspaId]/clients/[slug]/memberships/[clientMembershipId]/cancel",
  "/[medspaId]/clients/[slug]/visits-history",
  "/[medspaId]/clients/[slug]/wallet",
  "/[medspaId]/clients/[slug]/wallet/credit/[creditTypeId]",
  "/[medspaId]/clients/[slug]/wallet/product/add",
  "/[medspaId]/clients/[slug]/wallet/service/add",
  "/[medspaId]/clients/[slug]/wallet/service-product/add",
  "/[medspaId]/clients/[slug]/[tab]",
  "/[medspaId]/compliance-hub",
  "/[medspaId]/datadogtesterror",
  "/[medspaId]/inventory/retail-products/[productId]",
  "/[medspaId]/inventory/service-products/[productId]",
  "/[medspaId]/inventory/service-products/[productId]/lot/no-lot-number",
  "/[medspaId]/inventory/service-products/[productId]/lot/[lotId]",
  "/[medspaId]/inventory/[tab]",
  "/[medspaId]/invoices/new",
  "/[medspaId]/invoices/[invoiceId]",
  "/[medspaId]/invoices/[invoiceId]/add-custom-discount",
  "/[medspaId]/invoices/[invoiceId]/add-custom-fee",
  "/[medspaId]/invoices/[invoiceId]/add-custom-line-item",
  "/[medspaId]/invoices/[invoiceId]/add-package",
  "/[medspaId]/invoices/[invoiceId]/add-product-lines",
  "/[medspaId]/invoices/[invoiceId]/add-retail-product",
  "/[medspaId]/invoices/[invoiceId]/add-service-lines",
  "/[medspaId]/invoices/[invoiceId]/edit-discount-lines",
  "/[medspaId]/invoices/[invoiceId]/edit-fee-lines",
  "/[medspaId]/invoices/[invoiceId]/edit-line-item/[itemSlug]",
  "/[medspaId]/invoices/[invoiceId]/edit-product-lines",
  "/[medspaId]/invoices/[invoiceId]/payments",
  "/[medspaId]/invoices/[invoiceId]/payments/[paymentId]",
  "/[medspaId]/invoices/[invoiceId]/refunds",
  "/[medspaId]/invoices/[invoiceId]/refunds/[refundId]",
  "/[medspaId]/marketing/content-vault",
  "/[medspaId]/messages",
  "/[medspaId]/payroll/[tab]",
  "/[medspaId]/practice-accelerator",
  "/[medspaId]/provider-meetings",
  "/[medspaId]/referral",
  "/[medspaId]/reports",
  "/[medspaId]/reports/payouts",
  "/[medspaId]/reports/[id]",
  "/[medspaId]/review/charts",
  "/[medspaId]/review/gfe/[clientId]/form/edit",
  "/[medspaId]/review/gfe/[clientId]/form/new",
  "/[medspaId]/review/gfe/[clientId]/[tab]",
  "/[medspaId]/review/gfes",
  "/[medspaId]/review/sync-gfe/[clientId]/form/initiate",
  "/[medspaId]/review/sync-gfe/[clientId]/form/new",
  "/[medspaId]/review/sync-gfe/[clientId]/form/[documentId]/edit",
  "/[medspaId]/sales/[tab]",
  "/[medspaId]/scripts",
  "/[medspaId]/scripts/[scriptRequestId]/details",
  "/[medspaId]/settings",
  "/[medspaId]/settings/add-consent-form",
  "/[medspaId]/settings/add-intake-form",
  "/[medspaId]/settings/add-postcare-form",
  "/[medspaId]/settings/add-precare-form",
  "/[medspaId]/settings/availability",
  "/[medspaId]/settings/availability/regular-working-hours",
  "/[medspaId]/settings/availability/special-shifts",
  "/[medspaId]/settings/branding-customization",
  "/[medspaId]/settings/categories",
  "/[medspaId]/settings/charting",
  "/[medspaId]/settings/charting/diagrams",
  "/[medspaId]/settings/charting/note-templates",
  "/[medspaId]/settings/charting/note-templates/new",
  "/[medspaId]/settings/charting/note-templates/[slug]",
  "/[medspaId]/settings/client-communication",
  "/[medspaId]/settings/consent-forms",
  "/[medspaId]/settings/discounts-and-fees",
  "/[medspaId]/settings/discounts-and-fees/discounts",
  "/[medspaId]/settings/discounts-and-fees/discounts/create",
  "/[medspaId]/settings/discounts-and-fees/discounts/[slug]",
  "/[medspaId]/settings/discounts-and-fees/fees",
  "/[medspaId]/settings/discounts-and-fees/fees/create",
  "/[medspaId]/settings/discounts-and-fees/fees/[slug]",
  "/[medspaId]/settings/edit-compliance-task/[complianceTaskId]",
  "/[medspaId]/settings/edit-consent-form/[slug]",
  "/[medspaId]/settings/edit-intake-forms/[slug]",
  "/[medspaId]/settings/edit-postcare-form/[slug]",
  "/[medspaId]/settings/edit-precare-form/[slug]",
  "/[medspaId]/settings/forms",
  "/[medspaId]/settings/intake-forms",
  "/[medspaId]/settings/intake-forms/[slug]",
  "/[medspaId]/settings/medical-director/billing",
  "/[medspaId]/settings/medical-director/billing/[mdSubscriptionId]",
  "/[medspaId]/settings/medical-director/clinical-documents",
  "/[medspaId]/settings/medical-director/clinical-documents/types",
  "/[medspaId]/settings/medical-service-organization-setup",
  "/[medspaId]/settings/notifications",
  "/[medspaId]/settings/notifications/contacts",
  "/[medspaId]/settings/notifications/groups/[id]",
  "/[medspaId]/settings/notifications/user-medspa/[notificationUserMedspaId]",
  "/[medspaId]/settings/notifications/user-medspa/[notificationUserMedspaId]/contacts",
  "/[medspaId]/settings/notifications/user-medspa/[notificationUserMedspaId]/groups/[id]",
  "/[medspaId]/settings/online-booking",
  "/[medspaId]/settings/online-booking/selective-booking",
  "/[medspaId]/settings/online-booking/selective-booking/[id]",
  "/[medspaId]/settings/online-booking/time-restrictions",
  "/[medspaId]/settings/online-store",
  "/[medspaId]/settings/payments",
  "/[medspaId]/settings/payments/add-terminal",
  "/[medspaId]/settings/payments/cherry",
  "/[medspaId]/settings/payments/cherry/connect",
  "/[medspaId]/settings/payments/plans",
  "/[medspaId]/settings/policies-procedures",
  "/[medspaId]/settings/policies-procedures/new",
  "/[medspaId]/settings/policies-procedures/standing-orders",
  "/[medspaId]/settings/policies-procedures/standing-orders/upload",
  "/[medspaId]/settings/policies-procedures/upload",
  "/[medspaId]/settings/policies-procedures/[slug]",
  "/[medspaId]/settings/postcare-forms",
  "/[medspaId]/settings/precare-forms",
  "/[medspaId]/settings/privacy-and-telehealth-terms",
  "/[medspaId]/settings/privacy-and-telehealth-terms/edit",
  "/[medspaId]/settings/professional-corporation-setup",
  "/[medspaId]/settings/provider-business-setup",
  "/[medspaId]/settings/provider-business-setup/[providerId]",
  "/[medspaId]/settings/resources",
  "/[medspaId]/settings/resources/devices",
  "/[medspaId]/settings/resources/devices/create",
  "/[medspaId]/settings/resources/devices/[slug]",
  "/[medspaId]/settings/resources/rooms",
  "/[medspaId]/settings/resources/rooms/add",
  "/[medspaId]/settings/resources/rooms/[roomId]/edit",
  "/[medspaId]/settings/services-and-products",
  "/[medspaId]/settings/services-and-products/memberships",
  "/[medspaId]/settings/services-and-products/memberships/new",
  "/[medspaId]/settings/services-and-products/memberships/[slug]",
  "/[medspaId]/settings/services-and-products/memberships/[slug]/agreement",
  "/[medspaId]/settings/services-and-products/memberships/[slug]/basic-info",
  "/[medspaId]/settings/services-and-products/memberships/[slug]/billing",
  "/[medspaId]/settings/services-and-products/memberships/[slug]/perks",
  "/[medspaId]/settings/services-and-products/memberships/[slug]/perks/[perkId]",
  "/[medspaId]/settings/services-and-products/offerings",
  "/[medspaId]/settings/services-and-products/offerings/service-types",
  "/[medspaId]/settings/services-and-products/offerings/[serviceType]",
  "/[medspaId]/settings/services-and-products/offerings/[serviceType]/service-menu",
  "/[medspaId]/settings/services-and-products/offerings/[serviceType]/service-products",
  "/[medspaId]/settings/services-and-products/packages",
  "/[medspaId]/settings/services-and-products/packages/edit/[slug]",
  "/[medspaId]/settings/services-and-products/packages/new",
  "/[medspaId]/settings/services-and-products/retail-products",
  "/[medspaId]/settings/services-and-products/retail-products/edit/[slug]",
  "/[medspaId]/settings/services-and-products/retail-products/new",
  "/[medspaId]/settings/services-and-products/services",
  "/[medspaId]/settings/services-and-products/services/edit/[slug]",
  "/[medspaId]/settings/services-and-products/services/new",
  "/[medspaId]/settings/standing-orders",
  "/[medspaId]/settings/standing-orders/new",
  "/[medspaId]/settings/workforce",
  "/[medspaId]/settings/workforce/payroll",
  "/[medspaId]/settings/workforce/roles-configuration",
  "/[medspaId]/settings/workforce/roles-configuration/[slug]",
  "/[medspaId]/supplies",
  "/[medspaId]/supplies/[collectionName]",
  "/[medspaId]/time-blocks/new",
  "/[medspaId]/time-blocks/[slug]",
  "/[medspaId]/time-blocks/[slug]/edit",
  "/[medspaId]/visits",
  "/[medspaId]/visits/new",
  "/[medspaId]/visits/[slug]",
  "/[medspaId]/visits/[slug]/add-product-lines",
  "/[medspaId]/visits/[slug]/add-service-lines",
  "/[medspaId]/visits/[slug]/adverse-reactions/new",
  "/[medspaId]/visits/[slug]/adverse-reactions/[adverseReactionId]/edit",
  "/[medspaId]/visits/[slug]/attachments/forms",
  "/[medspaId]/visits/[slug]/attachments/images",
  "/[medspaId]/visits/[slug]/consent-forms",
  "/[medspaId]/visits/[slug]/consent-forms/[formSlug]",
  "/[medspaId]/visits/[slug]/create-follow-up-visit",
  "/[medspaId]/visits/[slug]/diagrams/new",
  "/[medspaId]/visits/[slug]/diagrams/[diagramSlug]/edit",
  "/[medspaId]/visits/[slug]/edit",
  "/[medspaId]/visits/[slug]/edit-product-lines",
  "/[medspaId]/visits/[slug]/images",
  "/[medspaId]/visits/[slug]/images/[imageSlug]/edit",
  "/[medspaId]/visits/[slug]/intake-forms/[formSlug]",
  "/[medspaId]/visits/[slug]/lab-records/new",
  "/[medspaId]/visits/[slug]/lab-records/[labRecordId]",
  "/[medspaId]/visits/[slug]/notes/new",
  "/[medspaId]/visits/[slug]/notes/new/blank",
  "/[medspaId]/visits/[slug]/notes/[noteId]/edit",
  "/[medspaId]/visits/[slug]/[tab]",
  "/[medspaId]/weight-loss-order/[pharmacy]"
] as const;

export default routes;
